import { useOidc } from '@axa-fr/react-oidc';
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import LoadingComponent from '../../loading/LoadingComponent';

const SSO = () => {
  const { login, isAuthenticated, isLoading, error } = useOidc();
  const navigate = useNavigate();
  const loginAttempted = useRef(false);

  console.log('[SSO] State:', { isAuthenticated, isLoading, error });

  useEffect(() => {
    // Si l'utilisateur est déjà authentifié, le rediriger vers le dashboard
    if (isAuthenticated) {
      console.log('[SSO] Already authenticated, redirecting...');
      const redirectPath =
        sessionStorage.getItem('redirectPath') || '/dashboard/products';
      sessionStorage.removeItem('redirectPath');
      navigate(redirectPath, { replace: true });
      return;
    }

    // Si il y a une erreur, rediriger vers la page d'erreur
    if (error) {
      console.error('[SSO] Authentication Error:', error);
      sessionStorage.setItem(
        'authError',
        JSON.stringify({
          message: 'Erreur de configuration SSO',
          details: typeof error === 'object' ? JSON.stringify(error) : error,
          timestamp: new Date().toISOString(),
        })
      );
      navigate('/auth/error', { replace: true });
      return;
    }

    // Si pas de chargement et pas authentifié, lancer l'authentification SSO
    // Utiliser un ref pour éviter les appels multiples
    if (!isLoading && !isAuthenticated && !loginAttempted.current) {
      loginAttempted.current = true;
      console.log('[SSO] Initiating login...');
      try {
        login();
      } catch (loginError) {
        console.error('[SSO] Login initiation error:', loginError);
        sessionStorage.setItem(
          'authError',
          JSON.stringify({
            message: "Impossible de démarrer l'authentification SSO",
            details:
              typeof loginError === 'object'
                ? JSON.stringify(loginError)
                : loginError,
            timestamp: new Date().toISOString(),
          })
        );
        navigate('/auth/error', { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, error, login, navigate]);

  // Afficher un loader pendant le processus d'authentification
  return <LoadingComponent />;
};

export default SSO;
